import FlagshipIcon from "../../assets/product-list-assets/wifi-flagship.svg";
import type { ProductListGroup } from "../../types";

export const wifiFlagship: ProductListGroup = {
  id: "wifiFlagship",
  title: "productListGroup.wifiFlagship.title",
  seriesLabel: "modelCompare.seriesLabel.wifiFlagship",
  icon: {
    src: FlagshipIcon,
    width: 16,
    height: 21,
  },
};
